var map = {
	"./apple-laurel-da-DK.svg": 47719,
	"./apple-laurel-de-DE.svg": 73269,
	"./apple-laurel-en-GB.svg": 24567,
	"./apple-laurel-en-US.svg": 7264,
	"./apple-laurel-es-ES.svg": 17111,
	"./apple-laurel-es-MX.svg": 41700,
	"./apple-laurel-fr-FR.svg": 42475,
	"./apple-laurel-it-IT.svg": 41469,
	"./apple-laurel-nb-NO.svg": 49478,
	"./apple-laurel-nl-NL.svg": 17891,
	"./apple-laurel-pl-PL.svg": 72839,
	"./apple-laurel-pt-BR.svg": 41191,
	"./apple-laurel-pt-PT.svg": 40567,
	"./apple-laurel-sv-SE.svg": 21798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87083;